import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import DataTable from '../../../Layout/Table/TableLayout';
import Navbar from '../../../Shared/Navbar/Navbar';
import { baseURL } from '../../../Apiservices/Api';
import { Button, Row, Col, Modal } from 'react-bootstrap';

const CredentialTable = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  // Fetch credentials
  const fetchCredentials = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${baseURL}/api/get-credentials`);
      setCredentials(res.data);
    } catch (error) {
      console.error("Error fetching credentials:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCredentials();
  }, []);

  // Delete handler
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this credential?')) {
      try {
        await axios.delete(`${baseURL}/api/delete-credentials/${id}`);
        fetchCredentials(); // Refresh data
      } catch (err) {
        console.error("Failed to delete credential:", err);
      }
    }
  };

  // Columns
  const columns = [
    {
      Header: "S.No",
      accessor: (_, i) => i + 1,
      Cell: ({ row }) => row.index + 1,
    },
    {
      Header: "Sender Email",
      accessor: "sender_email",
    },
    {
      Header: "App Password",
      accessor: "app_password",
    },
    {
      Header: "Actions",
      Cell: ({ row }) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <FaEdit
           style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => navigate(`/A_edit-credentials/${row.original.id}`, { state: row.original })}
          />
          <FaTrash
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => handleDelete(row.original.id)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="salesViewLeadsContainer">
    <Navbar onToggleSidebar={setCollapsed} />
    <div className={`salesViewLeads ${collapsed ? 'collapsed' : ''}`}>
      <div className="credentialsContent">
        <div className="tableHeader" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '30px' }}>
          <h3>Email Credentials</h3>
          

          <Button    onClick={() => navigate('/A_emailcredentials')}>Add Credential</Button>
        </div>

        <div style={{ marginTop: '20px' }}>
          <DataTable columns={columns} data={credentials} loading={loading} />
        </div>
      </div>
    </div>
    </div>
  );
};

export default CredentialTable;
